import {
  ControlBackgroundColors,
  ControlBorderColors,
  ControlTextColors,
} from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { createUseStyles } from 'react-jss';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';

const useStyles = createUseStyles(
  {
    createNew: {
      height: 292,
      marginBottom: Spacings.s24,
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: CornerRadius.r12,
      flexDirection: 'column',
      gap: Spacings.s12,
      border: `3px dashed ${ControlBorderColors.default}`,
      textAlign: 'center',
      overflow: 'auto',

      '&:hover': {
        background: ControlBackgroundColors.action,
        border: `3px dashed ${ControlBorderColors.action}`,
      },
    },
    icon: {
      height: 40,
      width: 40,
      fill: ControlTextColors.default,
    },
    text: {
      fontSize: FontSizes.s16,
      fontWeight: FontWeights.medium,
      lineHeight: LineHeights.l24,
      color: ControlTextColors.default,
    },
  },
  { name: 'first-element' },
);

export default useStyles;
